import { Component } from '@angular/core';

/**
 * The what happens next section of a legal entity review application.
 *
 * @export
 * @class LegalEntityReviewWhatHappensNextComponent
 */
@Component({
  selector: 'app-legal-entity-review-what-happens-next',
  templateUrl: './legal-entity-review-what-happens-next.component.html',
  styleUrls: ['./legal-entity-review-what-happens-next.component.scss']
})
export class LegalEntityReviewWhatHappensNextComponent {}
